
        var result = require("!!../../../../node_modules/css-loader/index.js!./discount.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/discount.component.css
// module id = 2343
// module chunks = 1